import { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Divider from "@material-ui/core/Divider";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";
import { useParams, useHistory } from "react-router-dom";
import { Paper } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";

import LicensesDashboard from "../components/Licenses/LicensesDashboard";
import HardwareList from "../components/Hardwares/HardwareList";
import { customersActions } from "../store/customers-slice";
import { licensesActions } from "../store/licenses-slice";
import { fetchCustomerById, updateCustomer } from "../store/customers-actions";

const useStyles = makeStyles((theme) => ({
  buttonMargin: {
    margin: theme.spacing(1),
  },
  stdMargin: {
    margin: theme.spacing(1, 0, 4, 0),
  },
}));

const CustomerForm = (props) => {
  return (
    <>
      <Typography gutterBottom variant="h5" className={props.classes.stdMargin}>
        Customer details
      </Typography>
      <Grid
        spacing={1}
        container
        direction="column"
        className={props.classes.buttonMargin}
      >
        <Grid item xs={11}>
          <TextField
            id="email"
            label="E-mail"
            fullWidth
            variant="outlined"
            aria-readonly
            InputProps={{
              readOnly: true,
            }}
            value={props.customer.email}
          />
        </Grid>
        <Grid item xs={11}>
          <Paper elevation={0}>
            <TextField
              id="name"
              label="Name"
              fullWidth
              variant="outlined"
              onChange={props.nameChange}
              value={props.customer.name}
            />
          </Paper>
        </Grid>
        <Grid item xs={11}>
          <Paper elevation={0}>
            <TextField
              id="company"
              label="Company"
              fullWidth
              variant="outlined"
              onChange={props.companyChange}
              value={props.customer.company}
            />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

const CustomerEdit = () => {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const customer = useSelector((state) => state.customers.selected);
  const classes = useStyles();

  const [isDirty, setIsDirty] = useState(false);

  const { customerId } = params;

  useEffect(() => {
    if (customerId) {
      dispatch(fetchCustomerById(customerId));
    }
    return () => {
      dispatch(customersActions.resetSelected());
      dispatch(licensesActions.resetSelected());
    };
  }, [customerId, dispatch]);

  const nameChangeHandler = (event) => {
    dispatch(customersActions.setName(event.target.value));
    setIsDirty(true);
  };
  const companyChangeHandler = (event) => {
    dispatch(customersActions.setCompany(event.target.value));
    setIsDirty(true);
  };

  const saveButtonHandler = () => {
    dispatch(
      updateCustomer({
        id: customer.id,
        name: customer.name,
        company: customer.company,
      })
    );
    setIsDirty(false);
  };

  const cancelButtonHandler = () => history.goBack();

  return (
    <>
      {customer && (
        <>         
          <Hidden smDown implementation="css">
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <CustomerForm classes={classes} nameChange = {nameChangeHandler} companyChange={companyChangeHandler} customer={customer} />
              </Grid>
              <Grid item xs={8}>
                <HardwareList />
              </Grid>           
            </Grid>
          </Hidden>
          <Hidden smUp implementation="css">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <CustomerForm classes={classes} nameChange = {nameChangeHandler} companyChange={companyChangeHandler} customer={customer} />
              </Grid>             
            </Grid>
          </Hidden>
          <LicensesDashboard customerId={customerId} />
          <Hidden smUp implementation="css">
            <HardwareList />
          </Hidden>
          <Divider variant="middle" className={classes.stdMargin} />
          <Grid
            container
            direction="row"
            justify="flex-end"
            alignItems="center"
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<ArrowBackIcon />}
              className={classes.buttonMargin}
              onClick={cancelButtonHandler}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="secondary"
              disabled={!isDirty}
              onClick={saveButtonHandler}
              startIcon={<SaveIcon />}
              className={classes.buttonMargin}
            >
              Save
            </Button>
          </Grid>
        </>
      )}
    </>
  );
};

export default CustomerEdit;
